import { NgClass, NgStyle } from '@angular/common';
import {
    ChangeDetectionStrategy, Component, Input, OnChanges,
    SimpleChanges,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { ProductPromotions } from '../../models/product-promotion-dates.model';

import { ProductPublicModels } from '@features/products/product';
import { DuttiDate, DuttiDateFormat } from '@frontend/common/duttidate';

@Component({
    selector: 'product-promotion-dates',
    templateUrl: './product-promotion-dates.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgClass,
        TranslateModule,
        NgStyle,
    ],
})
export class ProductPromotionDatesComponent implements OnChanges {
    @Input() public product: ProductPublicModels.PublicProduct;

    @Input() public isPageProduct?: boolean;

    @Input() public fontColor?: string;

    public promotionDateRange: ProductPromotions;

    public isPromoActive: boolean;

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.product?.currentValue !== changes.product?.previousValue && this.product?.promotions) {
            this.promotionDateRange = this.getPromotionDateRange(this.product.promotions);
            this.isPromoActive = this.setSizeOnPromotion();
        }
    }

    private setSizeOnPromotion(): boolean {
        const promotionDateRangeId = this.promotionDateRange?.promotionId;
        const { status } = this.product;
        const { selectedSize, selectedColor } = status;

        const isSizeSelected = !!selectedSize;
        const isPromoOnSizeSelected = selectedSize?.promotionId === promotionDateRangeId;
        const isPromoOnColors = selectedColor?.sizes?.some((size) => size.promotionId === promotionDateRangeId);

        return isPromoOnSizeSelected || isPromoOnColors && !isSizeSelected;
    }

    private getPromotionDateRange(promotions: ProductPromotions[]): ProductPromotions {
        const promotionDate = promotions.find(promo => promo.startDate && promo.endDate);

        const start = new DuttiDate(
            promotionDate?.startDate,
            DuttiDateFormat.DAY_MONTH_WITH_DOT
        ).format(DuttiDateFormat.DAY_MONTH_WITH_DOT);

        const end = new DuttiDate(
            promotionDate?.endDate,
            DuttiDateFormat.DAY_MONTH_WITH_DOT
        ).format(DuttiDateFormat.DAY_MONTH_WITH_DOT);

        if (promotionDate) {
            return {
                startDate: start, endDate: end, promotionId: promotionDate.promotionId, name: promotionDate.name,
            };
        }

        return null;
    }
}
